let fontSize = 10

;;(function (doc, win) {
  var docEl = doc.documentElement
  var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  var recalc = function () {
    var clientWidth = docEl.clientWidth
    if (!clientWidth) return
    var html = document.getElementsByTagName('html')[0]
    var oWidth = document.body.clientWidth
    html.style.fontSize = `${(oWidth / 1000) * fontSize}px` //2000的屏幕上调试，1rem = 20px
  }
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window)
function remBaseFontSize() {
  return fontSize
}
function px2rem(pxStr) {
  if (typeof pxStr === 'string' && pxStr.match(/\d+px/)) {
    return pxStr.replace(/([\d.]+)px/g, (match, $1) => {
      return `${Number($1) / remBaseFontSize()}rem`
    })
  } else {
    return pxStr
  }
}
function px2remValue(pxValue) {
  // return pxValue / remBaseFontSize()
  const htmlFontSize = Number(
    document.getElementsByTagName('html')[0].style.fontSize.replace('px', '')
  )
  // 拿到html的fontsize 多少px/htmlfontsize = 多少rem
  return pxValue / htmlFontSize
}
function rootFontSize() {
  return Number(document.getElementsByTagName('html')[0].style.fontSize.replace('px', ''))
}
function zoom() {
  const htmlFontSize = Number(
    document.getElementsByTagName('html')[0].style.fontSize.replace('px', '')
  )
  // console.log(htmlFontSize / fontSize, 'zoom')
  return htmlFontSize / fontSize //1000的屏幕上调试，zoom:1
}
export { remBaseFontSize, px2rem, px2remValue, zoom, rootFontSize }
